<script>
export default {
  functional: true,
  name: 'EmptyLayout',
  render(createElement, context) {
    document.title = 'МИС';
    return context.children;
  },
};
</script>
